import http from "@/shared/services/http";

export const createPickingList = (data: any) => http.post(`v1/picking-lists`, data);
export const listPickingListServeStockOutAndStockIn = (params: any) => http.get(`v1/picking-lists/list-serve-stockin-stockout`, { params });
export const singlePickingList = (id: number) => http.get(`v1/picking-lists/${id}`);
export const historyStockOut = (params: any) => http.get('v1/warehouses/history-stock-out', { params });